import { z } from 'zod'

import { ICGG2Tables } from '@fortem-monorepo/web-sdk'

export const IcGuidelineTables = ICGG2Tables.IC_GUIDELINES_TABLE_IDS
export type IcGuidelineTable = ICGG2Tables.IcGuidelinesTableId

export const ThresholdTypes = ['unit', 'percentage', 'basis_points'] as const
export type ThresholdType = (typeof ThresholdTypes)[number]

export const AggregationFunctions = ['sum'] as const
export type AggregationFunction = (typeof AggregationFunctions)[number]

const nullableString = z
  .string()
  .transform((v) => (v.trim() === '' ? null : v))
  .nullable()

export const guidelineSchema = z.object({
  id: z.number().nullable(),
  name: z.string().nonempty('Name must not be empty'),
  description: nullableString,
  table: z.enum(IcGuidelineTables),
  funds: z.array(z.number().int()).min(1, 'Must select at least 1 fund'),
  value_column: z.string().nonempty('Must select a value column'),
  aggregation_function: z.enum(AggregationFunctions).nullable(),
  threshold_type: z.enum(ThresholdTypes),
  identifiers: z
    .record(z.string(), z.string().nonempty('Each identifier must have a value'))
    .nullable(),
  thresholds: z
    .object({
      hard_upper: z.number().nullable(),
      hard_lower: z.number().nullable(),
      soft_upper: z.number().nullable(),
      soft_lower: z.number().nullable(),
    })
    .refine(
      (v) =>
        Object.values(v).some((v) => {
          return typeof v === 'number'
        }),
      'Thresholds must have at least one value present',
    ),
  is_active: z.boolean(),
})

export type GuidelineFormValues = z.infer<typeof guidelineSchema>
